const customStyles = {
  rows: {
    style: {
      minHeight: '95px', // altura mínima de fila
    //   padding: '0 16px', // padding horizontal
      fontSize: '14px',
    },
  },
  headCells: {
    style: {
    //   fontWeight: 'lighter',
    //   fontSize: '15px',
      padding: '0 16px',
    },
  },
  cells: {
    style: {
    //   padding: '0 16px',
    },
  },
};

export default customStyles;
